import { useEffect } from "react";
import { ListGroup, ListGroupItem } from "reactstrap";
import { BeamerBroadcastChannelSender } from "./BeamerBroadcastChannelSender";
import { CyCarousel } from "../carousel/CyCarousel";
import { LivePositionMarker } from "../live/LivePositionMarker";
import { PlaylistLivePositionPayload } from "../live/playlist/PlaylistLivePositionPayload";
import { useDeviceContext } from "../device/DeviceInfoContext";

interface Props {
  channel: BeamerBroadcastChannelSender;
  setActiveLyricsPart: (activeLyricsPart: number | undefined) => void;
  index: number;
  text: string;
  title?: string;
  isActive: boolean;
  playlistLivePositionArray: readonly PlaylistLivePositionPayload[];
}

export function SongsheetBeamerText({
  channel,
  setActiveLyricsPart,
  index,
  text,
  title,
  isActive,
  playlistLivePositionArray,
}: Props) {
  const { deviceIdentifier } = useDeviceContext();

  useEffect(() => {
    if (isActive) channel.sendText(text);
  }, [text, isActive, channel]);

  function generateDeviceInfo(index: number): React.ReactNode {
    return playlistLivePositionArray
      .filter((p: PlaylistLivePositionPayload) => {
        return (
          p.deviceIdentifier !== deviceIdentifier && // exclude own device
          p.currentLyricsPosition === index
        );
      })
      .map((p: PlaylistLivePositionPayload) => {
        return (
          <LivePositionMarker
            color={p.deviceColor}
            key={p.deviceIdentifier}
            deviceIdentifier={p.deviceIdentifier}
          />
        );
      });
  }

  return (
    <ListGroup
      horizontal
      style={{ flex: "1 1 auto", userSelect: "none" }}
      className="border-bottom"
    >
      <ListGroupItem
        active={isActive}
        action
        data-cy={CyCarousel.LyricsItem}
        className={
          "border-0 " + (isActive && "bg-primary text-dark bg-opacity-25")
        }
        onClick={() => setActiveLyricsPart(index)}
      >
        <div className="col">
          <div className="row">
            <div className="col-10">
              {title && (
                <div className="small fw-bold mb-1 opacity-75">{title}</div>
              )}
              <div className="d-flex">{text}</div>
            </div>
            <div className="col-2 d-flex justify-content-end align-items-start">
              {generateDeviceInfo(index)}
            </div>
          </div>
        </div>
      </ListGroupItem>
    </ListGroup>
  );
}
